"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactScriptTag = _interopRequireDefault(require("react-script-tag"));
var _reactRouterDom = require("react-router-dom");
var _booking = require("./helpers/booking");
var _LoadingView = _interopRequireDefault(require("./LoadingView"));
var _newComponents = require("./new-components");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var PaysafeBridge = /*#__PURE__*/function (_PureComponent) {
  function PaysafeBridge(props) {
    var _this;
    (0, _classCallCheck2["default"])(this, PaysafeBridge);
    _this = _callSuper(this, PaysafeBridge, [props]);
    _this.state = {
      formLoaded: false,
      error: undefined,
      loading: false,
      cardHolder: '',
      street: '',
      city: '',
      state: '',
      zip: '',
      country: '',
      termsAgreed: false
    };
    _this.handleScriptError = _this.handleScriptError.bind(_this);
    _this.handleScriptLoad = _this.handleScriptLoad.bind(_this);
    _this.onSubmit = _this.onSubmit.bind(_this);
    _this.paysafeCallback = _this.paysafeCallback.bind(_this);
    return _this;
  }
  (0, _inherits2["default"])(PaysafeBridge, _PureComponent);
  return (0, _createClass2["default"])(PaysafeBridge, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (window.paysafe) {
        this.handleScriptLoad();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      if (window.paysafe && !this.formHasLoaded()) {
        this.embedForm();
      }
    }
  }, {
    key: "onSubmit",
    value: function onSubmit(e) {
      var onSubmit = this.props.onSubmit;
      e.preventDefault();
      onSubmit();
      this.setState({
        loading: true,
        error: undefined
      });

      // Use 3DS (v2) for all card brands now:
      var useThreeDS = true;
      // const cardBrand = this.instance.getCardBrand();
      // // Only use 3D secure for MasterCard and Visa for now
      // if (cardBrand === 'MasterCard' || cardBrand === 'Visa') {
      //   useThreeDS = true;
      // }
      if (window.location.search.indexOf('skip3ds') > -1) {
        useThreeDS = false;
      }
      this.tokenize(useThreeDS);
    }
  }, {
    key: "tokenize",
    value: function tokenize() {
      var _this2 = this;
      var useThreeDS = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      var _this$props = this.props,
        paidAmount = _this$props.paidAmount,
        currency = _this$props.currency,
        accounts = _this$props.accounts,
        onError = _this$props.onError;
      var _this$state = this.state,
        cardHolder = _this$state.cardHolder,
        zip = _this$state.zip,
        country = _this$state.country,
        street = _this$state.street,
        city = _this$state.city,
        state = _this$state.state;
      var threeDS = {
        amount: paidAmount,
        currency: currency,
        accountId: accounts[currency],
        useThreeDSecureVersion2: true
      };
      var options = {
        vault: {
          holderName: cardHolder,
          billingAddress: {
            zip: zip,
            country: country.toUpperCase(),
            street: street || null,
            city: city || null,
            state: state || null
          }
        }
      };
      if (useThreeDS) {
        options.threeDS = threeDS;
      }
      this.instance.tokenize(options, function (instance, error, result) {
        if (error) {
          // display the tokenization error in dialog window
          console.error('Tokenize error', error, options);
          onError(error);
          _this2.setState({
            error: error,
            loading: false
          });
        } else {
          // write the Payment token value to the browser console
          _this2.props.onSuccess(result.token, cardHolder);
          _this2.setState({
            loading: false
          });
        }
      });
    }
  }, {
    key: "embedForm",
    value: function embedForm() {
      var _this3 = this;
      var _this$props2 = this.props,
        apiKey = _this$props2.apiKey,
        environment = _this$props2.environment;
      var options = {
        // select the Paysafe test / sandbox environment
        environment: environment,
        style: {
          input: {
            'font-family': 'Helvetica,Arial,sans-serif',
            'font-weight': 'normal',
            'font-size': '15px'
          }
        },
        fields: {
          cardNumber: {
            selector: '#cardNumber',
            placeholder: '**** **** **** ****'
          },
          expiryDate: {
            selector: '#expiryDate',
            placeholder: 'MM/YY'
          },
          cvv: {
            selector: '#cvv',
            placeholder: '***'
          }
        }
      };
      // initalize the hosted iframes using the SDK setup function
      window.paysafe.fields.setup(apiKey, options, function (instance, error) {
        _this3.instance = instance;
        _this3.paysafeCallback(error);
      });
    }
  }, {
    key: "paysafeCallback",
    value: function paysafeCallback(error) {
      if (error) {
        console.error(error);
      } else {
        this.setState({
          formLoaded: true
        });
      }
    }
  }, {
    key: "handleScriptError",
    value: function handleScriptError(error) {
      console.error(error);
    }
  }, {
    key: "formHasLoaded",
    value: function formHasLoaded() {
      if (!this._embed) {
        return false;
      }
      return this._embed && this._embed.innerHTML && this._embed.innerHTML.length > 0;
    }
  }, {
    key: "handleScriptLoad",
    value: function handleScriptLoad() {
      this.forceUpdate();
    }
  }, {
    key: "renderLoadingView",
    value: function renderLoadingView() {
      return /*#__PURE__*/_react["default"].createElement(_LoadingView["default"], {
        title: "Loading"
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;
      var _this$state2 = this.state,
        error = _this$state2.error,
        formLoaded = _this$state2.formLoaded,
        loading = _this$state2.loading,
        cardHolder = _this$state2.cardHolder,
        termsAgreed = _this$state2.termsAgreed,
        street = _this$state2.street,
        city = _this$state2.city,
        state = _this$state2.state,
        zip = _this$state2.zip,
        country = _this$state2.country;
      var _this$props3 = this.props,
        processing = _this$props3.processing,
        girls = _this$props3.girls,
        guys = _this$props3.guys,
        product = _this$props3.product,
        baseUrl = _this$props3.baseUrl,
        minAge = _this$props3.minAge,
        canCancelBooking = _this$props3.canCancelBooking;
      var isLoading = loading || processing;
      return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_reactScriptTag["default"], {
        src: "https://hosted.paysafe.com/js/v1/latest/paysafe.min.js",
        onError: this.handleScriptError,
        onLoad: this.handleScriptLoad
      }), /*#__PURE__*/_react["default"].createElement("form", {
        onSubmit: this.onSubmit,
        id: "paysafeform",
        className: "paysafe-form",
        style: {
          display: formLoaded ? 'block' : 'none'
        }
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "d8-c-input margin-bottom-md"
      }, /*#__PURE__*/_react["default"].createElement("label", {
        className: "form-label margin-bottom-sm",
        htmlFor: "cardNumber",
        "data-section": "form-label"
      }, "Credit Card Number"), /*#__PURE__*/_react["default"].createElement("div", {
        ref: function ref(div) {
          _this4._embed = div;
        },
        id: "cardNumber",
        className: "form-control",
        style: {
          height: '43px'
        }
      })), /*#__PURE__*/_react["default"].createElement("div", {
        className: "d8-c-input margin-bottom-md"
      }, /*#__PURE__*/_react["default"].createElement("label", {
        className: "form-label margin-bottom-sm",
        htmlFor: "cardHolder",
        "data-section": "form-label"
      }, "Cardholder's Name"), /*#__PURE__*/_react["default"].createElement("input", {
        placeholder: "Cardholder's name",
        id: "cardHolder",
        value: cardHolder,
        onChange: function onChange(e) {
          return _this4.setState({
            cardHolder: e.target.value
          });
        },
        className: "form-control"
      })), /*#__PURE__*/_react["default"].createElement("div", {
        className: "grid grid-gap-md"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "col-6 d8-c-input"
      }, /*#__PURE__*/_react["default"].createElement("label", {
        className: "form-label margin-bottom-sm flex",
        htmlFor: "expiryDate",
        "data-section": "form-label"
      }, "Valid Until"), /*#__PURE__*/_react["default"].createElement("div", {
        id: "expiryDate",
        className: "form-control",
        style: {
          height: '43px'
        }
      })), /*#__PURE__*/_react["default"].createElement("div", {
        className: "col-6 d8-c-input"
      }, /*#__PURE__*/_react["default"].createElement("label", {
        className: "form-label margin-bottom-sm flex",
        htmlFor: "cvv",
        "data-section": "form-label"
      }, /*#__PURE__*/_react["default"].createElement("span", {
        className: "margin-right-xs"
      }, "CVV"), /*#__PURE__*/_react["default"].createElement(_newComponents.Tooltip, {
        title: 'The ("Card Verification Value") on your credit card or debit card ' + 'is a 3-4 digit number located on the back/front of your card'
      }, /*#__PURE__*/_react["default"].createElement(_newComponents.Svg, {
        name: "info-i-fill",
        fill: _newComponents.COLORS.BLACK
      }))), /*#__PURE__*/_react["default"].createElement("div", {
        id: "cvv",
        className: "form-control",
        style: {
          height: '43px'
        }
      }))), /*#__PURE__*/_react["default"].createElement("h3", {
        className: "text-md"
      }, "Billing Address"), /*#__PURE__*/_react["default"].createElement("div", {
        className: "grid grid-gap-md"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "col-12 d8-c-input"
      }, /*#__PURE__*/_react["default"].createElement("label", {
        className: "form-label margin-bottom-sm",
        htmlFor: "street",
        "data-section": "form-label"
      }, "Street Address"), /*#__PURE__*/_react["default"].createElement("input", {
        placeholder: "Street name and number",
        id: "street",
        value: street,
        onChange: function onChange(e) {
          return _this4.setState({
            street: e.target.value
          });
        },
        className: "form-control"
      })), /*#__PURE__*/_react["default"].createElement("div", {
        className: "col-6 d8-c-input"
      }, /*#__PURE__*/_react["default"].createElement("label", {
        className: "form-label margin-bottom-sm flex",
        htmlFor: "city",
        "data-section": "form-label"
      }, "City"), /*#__PURE__*/_react["default"].createElement("input", {
        placeholder: "City",
        id: "city",
        value: city,
        onChange: function onChange(e) {
          return _this4.setState({
            city: e.target.value
          });
        },
        className: "form-control"
      })), /*#__PURE__*/_react["default"].createElement("div", {
        className: "col-6 d8-c-input"
      }, /*#__PURE__*/_react["default"].createElement("label", {
        className: "form-label margin-bottom-sm flex",
        htmlFor: "state",
        "data-section": "form-label"
      }, "State / Province / Region"), /*#__PURE__*/_react["default"].createElement("input", {
        placeholder: "State / Province / Region",
        id: "state",
        value: state,
        onChange: function onChange(e) {
          return _this4.setState({
            state: e.target.value
          });
        },
        className: "form-control"
      })), /*#__PURE__*/_react["default"].createElement("div", {
        className: "col-6 d8-c-input"
      }, /*#__PURE__*/_react["default"].createElement("label", {
        className: "form-label margin-bottom-sm flex",
        htmlFor: "zip",
        "data-section": "form-label"
      }, "Zip / Postal Code *"), /*#__PURE__*/_react["default"].createElement("input", {
        placeholder: "Zip / Postal Code",
        id: "zip",
        value: zip,
        onChange: function onChange(e) {
          return _this4.setState({
            zip: e.target.value
          });
        },
        className: "form-control"
      })), /*#__PURE__*/_react["default"].createElement("div", {
        className: "col-6 d8-c-select"
      }, /*#__PURE__*/_react["default"].createElement("label", {
        className: "form-label margin-bottom-sm flex",
        htmlFor: "country",
        "data-section": "form-label"
      }, "Country *"), /*#__PURE__*/_react["default"].createElement("span", {
        className: "d8-u-relative"
      }, /*#__PURE__*/_react["default"].createElement("select", {
        required: true,
        id: "country",
        value: country,
        onChange: function onChange(e) {
          return _this4.setState({
            country: e.target.value
          });
        },
        className: "form-control"
      }, /*#__PURE__*/_react["default"].createElement("option", {
        value: "",
        disabled: true,
        selected: true,
        hidden: true
      }, "Please Choose..."), _booking.countriesSorted.map(function (countryData) {
        return /*#__PURE__*/_react["default"].createElement("option", {
          value: countryData.code
        }, countryData.name.length > 24 ? "".concat(countryData.name.slice(0, 24), "...") : countryData.name);
      }))))), /*#__PURE__*/_react["default"].createElement(_newComponents.CheckBox, {
        id: "pay-terms-agreed",
        className: "margin-y-md",
        onChange: function onChange() {
          _this4.setState(function (prevState) {
            return {
              termsAgreed: !prevState.termsAgreed
            };
          });
        },
        checked: termsAgreed,
        label: /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, "I agree to ", product, "\u2019s", ' ', /*#__PURE__*/_react["default"].createElement("a", {
          className: "d8-u-color-secondary",
          href: "".concat(baseUrl, "/terms-and-conditions"),
          target: "_blank"
        }, "Terms and Conditions"), (girls || guys) && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, ' ', "- my ratio is ", girls, " and ", guys), minAge && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, ' ', "and all my crew will be aged ", minAge, " or over during the event"), ".")
      }), /*#__PURE__*/_react["default"].createElement("div", {
        className: "row margin-top-xl"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "col-xs-12 col-sm-6"
      }, !termsAgreed && /*#__PURE__*/_react["default"].createElement(_newComponents.Button, {
        text: isLoading ? 'Paying...' : 'Confirm booking and pay',
        disabled: true,
        fullWidth: true
      }), termsAgreed && /*#__PURE__*/_react["default"].createElement("button", {
        className: "btn btn--full-width ".concat(isLoading ? 'btn--disabled' : 'btn--success'),
        type: "submit",
        disabled: isLoading,
        form: "paysafeform"
      }, isLoading ? 'Paying...' : 'Confirm booking and pay'), canCancelBooking && /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Link, {
        className: "margin-top-sm block",
        to: "/booking/cancel"
      }, /*#__PURE__*/_react["default"].createElement(_newComponents.Button, {
        buttonType: _newComponents.BUTTON_TYPES.GHOST,
        fullWidth: true,
        text: "Cancel booking"
      }))))), !formLoaded && this.renderLoadingView(), error && /*#__PURE__*/_react["default"].createElement(_newComponents.Alert, {
        className: "margin-top-md",
        type: "error",
        text: "".concat(error.message, " ").concat(error.detailedMessage),
        show: error,
        onClose: function onClose() {
          return _this4.setState({
            error: null
          });
        }
      }));
    }
  }]);
}(_react.PureComponent);
PaysafeBridge.propTypes = {
  onSuccess: _propTypes["default"].func.isRequired,
  onError: _propTypes["default"].func.isRequired,
  processing: _propTypes["default"].bool.isRequired,
  paidAmount: _propTypes["default"].number.isRequired,
  currency: _propTypes["default"].string.isRequired,
  apiKey: _propTypes["default"].string.isRequired,
  environment: _propTypes["default"].string.isRequired,
  accounts: _propTypes["default"].object.isRequired,
  onSubmit: _propTypes["default"].func.isRequired,
  girls: _propTypes["default"].string,
  guys: _propTypes["default"].string,
  product: _propTypes["default"].string,
  baseUrl: _propTypes["default"].string,
  minAge: _propTypes["default"].number,
  canCancelBooking: _propTypes["default"].bool
};
var _default = exports["default"] = PaysafeBridge;